<template>
  <b-row v-if="item.lowest_parts">
    <b-col>
      <center>
        <span style="display-inline;">
          Lowest Parts:
          <b-button size="sm" variant="link" @click="$emit('showModal', 'lowestParts', item.lowest_parts)" class="px-0">
            <i class="fas fa-question-circle"></i>
          </b-button>
        </span>
      </center>
      <b-table :items="getTopLowestParts(item.lowest_parts)" class="internal-table" :striped="false"
        :fields="['partNum', 'desc', 'onShelf', 'quantityToBuild1', 'artificialQuantity', 'buildable']">
        <template slot="partNum" slot-scope="row">
          <router-link
            :to="{ path: '/inventory/qty-calculations', query: { partNum: row.item[0].replace(/^[\*]+|[\*]+$/g, '')}}"
            target="_blank"
          >{{ row.item[0] }}</router-link>
        </template>
        <template slot="desc" slot-scope="row">
          {{ descriptions[row.item[0].replace(/\*/g, '')] }} 
        </template>
        <template slot="onShelf" slot-scope="row">
          {{Math.round(row.item[1])}} {{uoms[row.item[0]]}}
        </template>
        <template slot="quantityToBuild1" slot-scope="row">
          {{Math.round(row.item[2])}} {{uoms[row.item[0]]}}
        </template>
        <template slot="artificialQuantity" slot-scope="row">
          {{Math.round(row.item[3])}} {{uoms[row.item[0]]}}
        </template>
        <template slot="buildable" slot-scope="row">
          {{Math.floor(row.item[4])}} {{uoms[item.part_num]}}
        </template>
      </b-table>
    </b-col>
  </b-row>
</template>

<script>
export default {
  props: {
    item: { type: Object, default: () => {} },
    descriptions: { type: Object, default: () => {} },
    uoms: { type: Object, default: () => {} },
  },
  methods: {
    getTopLowestParts(lowestParts) {
      return lowestParts.split(';').map(item => {
        let i = item.split(',')
        i.push(i[3]/i[2]);
        if (i[4] == 0) i._rowVariant = 'red';
        else if (i[4] < 10) i._rowVariant = 'orangered';
        else if (i[4] < 40) i._rowVariant = 'orange';
        else if (i[4] < 100) i._rowVariant = 'yellow';
        else i._rowVariant = 'lightgreen';

        i._cellVariants = { partNum: 'white' }

        return i;
      });
    }
  }
}
</script>

<style>
.table-red { background-color: red !important; }
.table-orangered { background-color: orangered !important; }
.table-orange { background-color: orange !important; }
.table-yellow { background-color: yellow !important; }
.table-lightgreen { background-color: lightgreen !important; }
.table-white { background-color: white !important; }
</style>



// WEBPACK FOOTER //
// src/components/inventory/LowestPartsData.vue